import React,{useState} from 'react';


const Navbar = () => {
  return (
<nav className="navbar">
  <div className="navbar-logo">
    <img src="rama_logo.jpg" alt="Logo" className="navbar-logo-image" />
  </div>
  <ul className="navbar-links">
    <li><a href="/">Home</a></li>
    <li><a href="/about-us">About Us</a></li>
    <li className="dropdown">
      <span className="dropdown-button">Our Institutes</span> {/* Changed from <a> to <span> */}
      <ul className="dropdown-content">
        <li><a href="/rcn">Rama College Of Nursing</a></li>
        <li><a href="/rce">Rama College of Education</a></li>
        <li><a href="/rsss">Rama Sr .Sec.School</a></li>
        <li><a href="/riti">Rama Pvt. ITI</a></li>
        
      </ul>
    </li>
    <li><a href="/rules">Rules and Regulations</a></li>
     <li><a href="/documents">Documents</a></li>
    <li><a href="/gallery">Media Gallery</a></li>
    <li><a href="/fees">Pay Fees</a></li>
    <li><a href="/contact-us">Contact Us</a></li>
  </ul>
</nav>

  );
};

export default Navbar;
